import factory from '../transactions/single-transaction/single-transaction-factory';

export default factory({
  assetCategory: 'fxForwards',

  transactionFragmentExtend: {
    currency: true,
    type: true,
    amount: true,
  },
});
